<template>
  <div class="param" v-if="DATA.productSpuAttribute.length > 0">
    <div class="name">· 基本参数 ·</div>
    <ul class="list">
      <li v-for="item in DATA.productSpuAttribute">
        <p :title="item.attribute + '：' + item.attributeValue">{{item.attribute}}：{{item.attributeValue}}</p>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
      data: Object
    },
    data () {
      return {
        DATA: this.data
      }
    }
  }
</script>

<style lang="less" scoped>
  .param {
    padding: 20px 30px 30px;
    background-color: white;
    border: 1px solid #eee;
    .name {
      padding-bottom: 20px;
      text-align: center;
      font-weight: bold;
      font-size: 16px;
      color: #333;
    }
    .list {
      overflow: hidden;
      font-size: 12px;
      li {
        float: left;
        width: 33.333%;
        list-style: none;
      }
      p {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-right: 2em;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/list-detail/sr-param.vue